module.exports = __webpack_public_path__ + "static/media/icon_taste.f32f08ce.svg";